export default __webpack_public_path__ + "static/media/853.9ca66240.png";